import { CustomError } from 'ts-custom-error'

import { fixStack } from './asyncHelpers'
import { Level } from './Level'

type Data = Record<string, any>

export class DefaultError extends CustomError {
	public level: Level
	public isHandled = false
	public data: Record<string, any>

	public constructor(message: string, data: Data = {}, level = Level.Error, cause?: unknown) {
		super(message, { cause })
		this.data = data
		this.level = level
	}

	public static fromError(error: any, data?: Data) {
		if (error instanceof Error) {
			return fixStack(error, new DefaultError(error.message, { ...data, ...error.data }))
		}
		if (typeof error === 'string') {
			return new DefaultError(error, data)
		}
		return new DefaultError(`Invalid error of type '${typeof error}'`, data)
	}
}
